module.exports = __webpack_public_path__ + "img/6.0b4ec77a.png";